import { useContext, useMemo } from 'react';

import { CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME } from '../../campaignFormStepOne.constants';
import DescriptionField from '../formFields/descriptionField/descriptionField';
import ProductsFields from '../formFields/productsField/productsField';
import PeriodField from '../formFields/periodFields/periodFields';
import DeliveryCompanyField from '../formFields/deliveryCompanyField/deliveryCompanyField';
import CampaignFormStepButtons from '../../../../../campaignFormStepButtons/campaignFormStepButtons';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepOneContext } from '../../campaignFormStepOne.context';

const FashionCampaignFormStepOne = () => {
  const {
    brand,
    setStep,
    updateCampaignId,
    storeOrUpdateTemporaryCampaignMutate,
    showLoader,
    setShowLoader,
  } = useContext(CampaignFormContext);
  const { isFormValid, getStepOneCampaignFormValues } = useContext(
    CampaignFormStepOneContext,
  );

  const formFieldComponents = useMemo(() => {
    return [
      ...(!brand.isWholesale
        ? [CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.BRAND_DESCRIPTION]
        : []),
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PRODUCT,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PERIOD,
      CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.DELIVERY_COMPANY,
    ];
  }, [brand?.isWholesale]);

  const onClickNext = () => {
    if (!showLoader) {
      if (updateCampaignId) {
        setStep((prevStep) => prevStep + 1);
      } else {
        setShowLoader(true);
        storeOrUpdateTemporaryCampaignMutate({
          campaign: getStepOneCampaignFormValues({
            fieldNames: ['description'],
          }),
          options: {
            onSuccess: () => {
              setStep((prevStep) => prevStep + 1);
            },
          },
        });
      }
    }
  };

  return (
    <>
      {formFieldComponents.map((formFieldType, index) => {
        const key = `fashion-campaign-form-step-one-form-filed-${index}`;
        const elementIndex = index + 1;

        switch (formFieldType) {
          // 브랜드 한 문장 소개
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.BRAND_DESCRIPTION: {
            return <DescriptionField key={key} elementIndex={elementIndex} />;
          }
          // 제품 정보
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PRODUCT: {
            return <ProductsFields key={key} elementIndex={elementIndex} />;
          }
          // 캠페인 기간
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.PERIOD: {
            return <PeriodField key={key} elementIndex={elementIndex} />;
          }
          // 이용 예정 택배사
          case CAMPAIGN_FORM_STEP_ONE_FIELD_COMPONENT_NAME.DELIVERY_COMPANY: {
            return (
              <DeliveryCompanyField key={key} elementIndex={elementIndex} />
            );
          }
        }
      })}

      <CampaignFormStepButtons
        disabledNextButton={!isFormValid}
        onClickNext={onClickNext}
      />
    </>
  );
};

export default FashionCampaignFormStepOne;
